const orderHr = {
    "total": "Ukupno",
    "order_successfully_placed": "Narudžba poslana",
    "empty_cart": "Vaša košarica je trenutno prazna",
    "place_order": "Naruči",
    "i_order": "Naruči",
    "order_confirmation": "Potvrda narudžbe",
    "order_confirmation_msg_raw": "Narudžbom prihvaćate naše uvjete korištenja i našu politiku privatnosti, koje možete pronaći na <a href=\":link\" class=\"generated-link\" target=\"_blank\">donjoj poveznici</a>.",
    "status_PLACED": "Postavljeno",
    "status_ACCEPTED": "Prihvaćeno",
    "status_SERVED": "Posluženo",
    "status_PAID": "Plaćeno",
    "empty_pending_orders": "Trenutno nemate narudžbi na čekanju",
    "overview": "Pregled narudžbe",
    "note": "Bilješka",
    "items": "Stavke",
    "review_order": "Pregled"
};

export default orderHr;
